import { __awaiter, __generator } from "tslib";
var findPageInSiteStructure = function (wixcodeApi, pageId) { return __awaiter(void 0, void 0, void 0, function () {
    var siteStructure;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, wixcodeApi.site.getSiteStructure({ includePageId: true })];
            case 1:
                siteStructure = _a.sent();
                return [2 /*return*/, siteStructure.pages.find(function (p) { return p.id === pageId; })];
        }
    });
}); };
var isTemplatePage = function (page) {
    return page.type === 'template';
};
var getReferringPageByTemplatePage = function (wixcodeApi, navigationContext, templatePage) { return __awaiter(void 0, void 0, void 0, function () {
    var pagePath, site, siteMap, routerPage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                pagePath = navigationContext.pagePath;
                if (!templatePage.prefix) {
                    return [2 /*return*/, getReferringPageByStaticPage(templatePage)];
                }
                if (!pagePath || pagePath.length === 0) {
                    return [2 /*return*/];
                }
                site = wixcodeApi.site;
                /* istanbul ignore if reason: need to be exposed from native-components-infra */
                if (!site.routerSitemap) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, site.routerSitemap(templatePage.prefix)];
            case 1:
                siteMap = _a.sent();
                routerPage = siteMap.find(function (p) { return p.url === pagePath.join('/'); });
                if (routerPage) {
                    return [2 /*return*/, {
                            url: "/".concat(templatePage.prefix, "/").concat(routerPage.url),
                            title: templatePage.tpaPageId ? routerPage.title : templatePage.name,
                            pageId: routerPage.pageName,
                        }];
                }
                return [2 /*return*/];
        }
    });
}); };
/* istanbul ignore else */
var getReferringPageByStaticPage = function (staticPage) {
    return {
        url: staticPage.url,
        title: staticPage.name,
        pageId: staticPage.id,
    };
};
export var getReferringPage = function (wixcodeApi, navigationContext) { return __awaiter(void 0, void 0, void 0, function () {
    var pageId, page;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                pageId = navigationContext.pageId;
                if (!pageId) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, findPageInSiteStructure(wixcodeApi, pageId)];
            case 1:
                page = _a.sent();
                if (!page) {
                    return [2 /*return*/];
                }
                if (isTemplatePage(page)) {
                    return [2 /*return*/, getReferringPageByTemplatePage(wixcodeApi, navigationContext, page)];
                }
                else {
                    return [2 /*return*/, getReferringPageByStaticPage(page)];
                }
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=sitemapUtils.js.map